import React from "react";

const CarTalonario = ({ datos }) => {
  const talonario = datos || {};

  // Los tres meses del talonario vienen como campos planos (mes_1..mes_3)
  const meses = [
    { mes: talonario.mes_1, fecha: talonario.fecha_mes_1, npe: talonario.npe_1, npeMulta: talonario.npe_multa_1 },
    { mes: talonario.mes_2, fecha: talonario.fecha_mes_2, npe: talonario.npe_2, npeMulta: talonario.npe_multa_2 },
    { mes: talonario.mes_3, fecha: talonario.fecha_mes_3, npe: talonario.npe_3, npeMulta: talonario.npe_multa_3 },
  ];

  return (
    <div>
      {meses.map((cuota, i) => (
        <div className="card" key={i}>
          <div className="card-body">
            <h5 className="card-title mb-3">{cuota.mes}</h5>
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr>
                    <th scope="row">Tipo</th>
                    <td>{talonario.nombre_tipo_cobro}</td>
                  </tr>
                  <tr>
                    <th scope="row">Pagar</th>
                    <td><b>${talonario.valor_cobro}</b></td>
                  </tr>
                  <tr>
                    <th scope="row">Sin recargo hasta</th>
                    <td>
                      <span className="esen-chip esen-chip--info">
                        <i className="fa fa-calendar" aria-hidden="true"></i>
                        {cuota.fecha}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">NPE</th>
                    <td>{cuota.npe}</td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <span className="esen-chip esen-chip--warning">
                        <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        Por pago extemporáneo incluye multa
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Total por pago extemporáneo</th>
                    <td>{talonario.valor_multa}</td>
                  </tr>
                  <tr>
                    <th scope="row">NPE con multa</th>
                    <td><b>{cuota.npeMulta}</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CarTalonario;
